import React from 'react';
import { css } from '@corti/style';
import { Base } from 'lib/cortiUI';
export function AlertThumbnailView(props) {
    const { imgUrl } = props;
    return (React.createElement(Base, { width: 44, height: 44, display: "flex", alignItems: "center", justifyContent: "center", className: css({ border: '1px solid #fff', borderRadius: '50%', overflow: 'hidden' }) },
        React.createElement("img", { src: imgUrl, className: css({ height: '110%', width: '110%' }) })));
}
